import React, { createContext, useCallback, useContext, useState } from "react";

const NotifyDesktopVideoPlayingContext = createContext<
  ((delta: 1 | -1) => void) | null
>(null);

const DesktopVideoPlayingCountContext = createContext<number>(0);

export const InnovationVideoPlayingProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [desktopVideoPlayingCount, setCount] = useState(0);

  const notifyDesktopVideoPlaying = useCallback((delta: 1 | -1) => {
    setCount((c) => Math.max(0, c + delta));
  }, []);

  return (
    <NotifyDesktopVideoPlayingContext.Provider value={notifyDesktopVideoPlaying}>
      <DesktopVideoPlayingCountContext.Provider value={desktopVideoPlayingCount}>
        {children}
      </DesktopVideoPlayingCountContext.Provider>
    </NotifyDesktopVideoPlayingContext.Provider>
  );
};

/** Callback stable : ne provoque pas de re-render des cartes quand le compteur change. */
export function useNotifyInnovationDesktopVideoPlaying(): ((delta: 1 | -1) => void) | null {
  return useContext(NotifyDesktopVideoPlayingContext);
}

export function useInnovationDesktopVideoPlayingCount(): number {
  return useContext(DesktopVideoPlayingCountContext);
}
